import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {validate} from 'codelyzer/walkerFactory/walkerFn';

@Component({
  selector: 'app-information-actions',
  templateUrl: './information-actions.component.html',
  styleUrls: ['./information-actions.component.scss']
})
export class InformationActionsComponent implements OnInit {
  @Input() data: any;
  form: FormGroup;

  constructor(private fb: FormBuilder,
              public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      id: [this.data.id || null],
      typeId: [this.data.typeId || null, [Validators.required]],
      subTitle: [this.data.subTitle || null, [Validators.required]],
      subTitleId: [''],
      orderId: [this.data.orderId || null, [Validators.required]],
      informationLink: this.fb.array([], [Validators.required])
    });
    if (this.data.link) {
      this.data.link.forEach((x) => this.addLink(x));
    } else {
      this.addLink(null);
    }
  }

  send(): void {
    const emitted = this.form.value;
    for (const item in emitted) {
      if (emitted.hasOwnProperty(item) && emitted[item] === null) {
        delete emitted[item];
      }
    }
    this.activeModal.close(emitted);
  }

  get informationLink() {
    return this.form.controls['informationLink'] as FormArray;
  }

  addLink(links ?: any[]): void {
    const form = this.fb.group({
      name: [links ? links['name'] : null],
      url: [links ? links['url'] : null],
      content: [links ? links['content'] : null],
      orderId: [links ? links['orderId'] : null, [Validators.required]]
    });
    this.informationLink.push(form);
  }

  deleteLink(index: number): void {
    this.informationLink.removeAt(index);
  }
}
